import React from 'react';
import Layout from '@/components/Layout';
import PageHeader from '@/components/PageHeader';
import CtaBand from '@/components/CtaBand';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const OPENINGS = [
  { title: 'Experienced Painter', location: 'Palm Beach Gardens', type: 'Full-time' },
  { title: 'Flooring Installer', location: 'Boca Raton', type: 'Full-time' },
  { title: 'Handyman / Technician', location: 'Wellington', type: 'Full-time' },
  { title: 'Project Manager', location: 'West Palm Beach', type: 'Full-time' },
  { title: 'Estimator', location: 'Hybrid', type: 'Full-time' },
  { title: 'Customer Care Specialist', location: 'Remote', type: 'Part-time' },
];

export default function CareersPage() {
  return (
    <Layout>
      <PageHeader eyebrow="Careers" title="Build with us." subtitle="We're growing across South Florida. Join a crew that pays well, treats people right, and takes craft seriously." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {OPENINGS.map((o, i) => (
            <div key={i} className="rounded-2xl border border-[#E6E9EE] bg-white p-5 flex items-center justify-between gap-3">
              <div>
                <div className="font-headline text-xl text-[#17352D]">{o.title}</div>
                <div className="text-sm text-slate-600 mt-0.5">{o.location} · {o.type}</div>
              </div>
              <Button asChild className="rounded-xl bg-[#17352D] hover:bg-[#1E4338] text-white">
                <a href="mailto:support@Royalpalmservice.com?subject=Application">Apply <ArrowRight className="h-4 w-4 ml-1" /></a>
              </Button>
            </div>
          ))}
        </div>
      </section>
      <CtaBand title="Don't see your role? Send us a note anyway." />
    </Layout>
  );
}
